/* eslint-disable react/no-array-index-key */
import React, { Component } from 'react';
import Img from '../../Img';

import styles from './team.module.scss';

const bgImg = (imageObj) => {
    if (imageObj && imageObj.oneX && imageObj.twoX && imageObj.threeX) {
        return (
            <Img
                useRawSrcSet={true}
                src={imageObj.oneX}
                srcSet={`${imageObj.twoX} 2x, ${imageObj.threeX} 3x`}
            />
        );
    } if (imageObj && imageObj.default) {
        return (
            <Img
                src={imageObj.default}
            />
        );
    }
    return null;
};

const Tile = (props) => {
    const { data } = props;
    const nameArr = data && data.favorite_player ? data.favorite_player.split(' ') : [];
    const [firstName, ...lastName] = nameArr;

    return (
        <div className={`team-tile`}>
            <picture className={`${styles.img} d-none d-sm-block`}>
                {data && data.image && data.image.desktop && bgImg(data.image.desktop)}
            </picture>
            <picture className={`${styles.img} d-block d-sm-none`}>
                {data && data.image && data.image.mobile && bgImg(data.image.mobile)}
            </picture>
            <div className={`hover-overlay`}>
                <div />
                <div className={`name`}>{firstName} <br />{lastName ? <span className="text-bold">{lastName.join(' ')}</span> : ''}</div>
            </div>
        </div>
    );
};

class Team extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    /* fill(arr, count) {
        const l = arr.length;
        if (l < count) {
            for (let i = count - 1 - l; i >= 0; i--) {
                arr[i + l] = arr[i % l];
            }
        }
        return arr;
    } */

    render() {
        const { team, title, description } = this.props;
        // const line = this.fill(team, 40);
        return (
            <div className={styles.section}>
                <div className={`container`}>
                    {title && <h3 className={styles.title}>{title}</h3>}
                    {description && <p className={`text-medium text-center mb25`}>{description}</p>}
                </div>
                <div className={`team-tile-container`}>
                    {team.map((tile, i) => <Tile data={tile} key={`tm${i}`} />)}
                </div>

                {/* <div className={`team-tile-container c1`}>
                    {line.map((tile, i) => <Tile data={tile} key={`c1${i}`}/>)}
                </div>
                <div className={`team-tile-container c2`}>
                    {line.map((tile, i) => <Tile data={tile} key={`c2${i}`} />)}
                </div>
                <div className={`team-tile-container c3`}>
                    {line.map((tile, i) => <Tile data={tile} key={`c3${i}`} />)}
                </div> */}
            </div>
        );
    }
}

export default Team;
